import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { ProductId, ProductReEntryPeriodDays } from 'services/products/types';
import { makeSelectProductFieldValue } from 'services/products/selectors';
import { numberOfDays } from 'utils/formatter/number-of-days';

export interface OwnProps {
    productId: ProductId;
}

export interface ConnectedProps {
    reEntryPeriodDays: ProductReEntryPeriodDays;
}

type Props = OwnProps & ConnectedProps;

export class SummaryProductReEntryPeriodListItemComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { reEntryPeriodDays } = this.props;

        return (
            <ListItem
                description="Re-entry period"
                value={numberOfDays(reEntryPeriodDays)}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    reEntryPeriodDays: makeSelectProductFieldValue('reEntryPeriodDays')
});

export default connect(mapStateToProps)(
    SummaryProductReEntryPeriodListItemComponent
);
